<ibm-loading [isActive]="true"
    [size]="'normal'"
    [overlay]="true"></ibm-loading>